<template>
  <div>
    <hvc-nav />
    <about-view />

    <div id="arts">
      <section class="section is-medium">
        <h1 class="title is-1 has-text-white">Art Collection</h1>
        <div class="container">
          <gallery-view />
        </div>
      </section>
    </div>

    <div class="container display_section">
      <p class="title is-3 has-text-white">Are you a shop owner that wishes to carry my product?</p>
      <p>With shop owners, I can do <i>wholesale</i> business with minimum CAD2000 order.</p>
      <p>Please use the Contact form to request HVC_{{ new Date().getFullYear() }}_catalog.</p><br><br>

      <p class="title is-4 has-text-white">What else do I make?</p>
      <p>I also offer <i>cremation</i> glass work for your beloved pets
        <font-awesome-icon :icon="['fas', 'dog']" size="2x" />
        <font-awesome-icon :icon="['fas', 'cat']" size="2x" />
      </p>
      <p>Please use the Contact form to inquiry the price and details.</p>
    </div>

    <div id="contact">
      <section class="section is-medium">
        <p class="title is-1 has-text-white">Contact</p>
        <p class="subtitle is-6 has-text-white">It may take up to 7 business days for me to get back to you, please be patient :)</p>
        <div class="container">
          <contact-view />
        </div>
      </section>
    </div>

    <footer class="footer">
        <div class="content has-text-centered">
          <font-awesome-icon :icon="['fab', 'facebook']" size="2x" class="icon-margin" @click="goFacebook"/>
          <font-awesome-icon :icon="['fab', 'instagram']" size="2x" class="icon-margin" @click="goInstagram"/>
          <font-awesome-icon :icon="['fab', 'youtube']" size="2x" class="icon-margin" @click="goYoutube"/>
          <p><img class="logo" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvclogo.png?alt=media" width="80"></p>
          <!-- <p></p> -->
          <p style="font-size:10px;">{{ new Date().getFullYear() }}  &copy; HiddenVillageCreations</p>
        </div>
      </footer>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import AboutView from './About.vue'
import GalleryView from './Gallery.vue'
import ContactView from './Contact.vue'

export default {
  name: 'home',
  components: {
    'hvc-nav': Nav,
    AboutView,
    GalleryView,
    ContactView
  },
  methods: {
    goFacebook() {
      window.open("https://www.facebook.com/MikeAstralHVC", '_blank');
    },
    goInstagram() {
      window.open("https://www.instagram.com/hiddenvillagecreations", '_blank');
    },
    goYoutube() {
      window.open("https://www.youtube.com/channel/UCnhslU8Yp8HBUvJDaWGlNIw", '_blank');
    }
  }
}
</script>

<style>
.display_section {
  padding: 20px;
  border: 5px solid #f1f1f1;
  color: #fff;
}

.sentence-margin {
  margin: 5px;
  padding: 10px;
}
</style>
